import React, { useState, useEffect } from 'react';
import { Form, Input, InputNumber, DatePicker, Switch, Button, Modal, notification, Spin, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

import config from '../../../../../../config/config.json';
import WasteTypeSelect from '../../../../../../components/WasteTypeSelect';
import MeasurementUnitSelect from '../../../../../../components/MeasurementUnitSelect';

const langContext = 'reserved-area.construction';

export default ({ construction_uid, uid, onClose, onLoad }) => {
  const [data, setData] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();


  useEffect(() => {
    if (uid) {
      setLoading(true);
      _service({
        method: 'GET',
        url: '/construction/waste/produce',
        data: { uid },
        success: (response) => {
          const responseData = response.json;
          responseData.estimated_date = moment(responseData.estimated_date, 'YYYY-MM-DD');
          setData(response.json);
          setLoading(false);
        },
        fail: (e) => {
          notification["error"]({
            message: 'Erro no carregamento dos dados dos Residuos a produzir',
            description: e.response.json.error,
          });
        }
      });
    }
  }, []);

  const intl = useIntl();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const disabledDate = (current) => {
    return current && current.isBefore(moment().subtract(1, 'days'));
  };

  const onSubmit = () => {
    setSubmitting(true);
    form.submit();
  };

  const onCancel = () => {
    setIsModalVisible(false);
    if (onClose) {
      onClose();
    }
  };
  const onChange = (value) => {
    console.log('changed', value);
  };

  function onFinish(values) {
    setSubmitting(true);
    const { waste_type, amount, measurement_unit, own_transport } = values;
    const estimated_date = values.estimated_date.format('YYYY-MM-DD');
    const formData = new FormData();
    if (uid) {
      formData.append('uid', uid);
    }
    formData.append('construction_uid', construction_uid);
    formData.append('waste_type_uid', waste_type.uid);
    formData.append('amount', amount);
    formData.append('measurement_unit_uid', measurement_unit.uid);
    formData.append('estimated_date', estimated_date);
    formData.append('own_transport', own_transport);
    if (values.photo && values.photo.fileList[0]) {
      formData.append('photo', values.photo.fileList[0].originFileObj);
    }
    if (uid) {
      _service({
        method: 'POST',
        url: '/construction/waste/produce',
        data: formData,
        success: (response) => {
          if (response.json.result) {
            notification["success"]({
              message: 'Resíduo a Produzir editado com sucesso',
            });
            setLoading(false);
            setSubmitting(false);
            setIsModalVisible(false);
            if (onLoad) {
              onLoad();
            }
            if (onClose) {
              onClose();
            }
          } else {
            notification["warning"]({
              message: 'Não foi possível editar o Resíduo a Produzir',
              description: response.json.error,
            });
            setSubmitting(false);
          }
        },
        fail: (e) => {
          notification["error"]({
            message: 'Não foi possível editar o Resíduo a Produzir, contacte-nos através do chat de suporte.',
          });
        }
      });
    } else {
      _service({
        method: 'PUT',
        url: '/construction/waste/produce',
        data: formData,
        success: (response) => {
          if (response.json.result) {
            notification["success"]({
              message: 'Resíduo a Produzir criado com sucesso.'
            });
            setLoading(false);
            setSubmitting(false);
            setIsModalVisible(false);
            if (onLoad) {
              onLoad();
            }
            if (onClose) {
              onClose();
            }
          } else {
            notification["warning"]({
              message: 'Resíduo a Produzir não foi criado com sucesso',
              description: response.json.error,
            });
            setSubmitting(false);
          }
        },
        fail: (e) => {
          notification["error"]({
            message: 'Não foi possível criar o Resíduo a Produzir, contacte-nos através do chat de suporte.'
          });
        }
      });
    }
  };

  function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
    setSubmitting(false);
  }

  const uploadCustomRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const uploadBeforeValidation = (file) => {
    const isPhoto = file.type === 'image/jpg' || file.type === 'image/jpeg';
    if (!isPhoto) {
      notification["error"]({
        message: 'Ficheiro Inválido',
        description: 'Apenas é permitido ficheiro de imagem do tipo JPG.',
      });
    }
    return isPhoto || Upload.LIST_IGNORE;
  };

  return (
    <>
      <Modal
        title={intl.formatMessage({ id: langContext + '.waste.to-produce.title' })}
        visible={true}
        onOk={onSubmit}
        onCancel={onCancel}
        footer={[
          <Button onClick={onCancel}>
            <FormattedMessage id={`${langContext}.button.cancel`} />
          </Button>,
          <Button type="primary" htmlType="submit" loading={submitting} onClick={onSubmit}>
            <FormattedMessage id={`${langContext}.button.save`} />
          </Button>]}
      >
        {loading ? <Spin /> :
          <Form
            form={form}
            layout='vertical'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={data}
          >
            <Form.Item
              name={['waste_type', 'uid']}
              label={intl.formatMessage({ id: langContext + '.fields.waste-type' })}
              rules={[
                { required: true }
              ]}
            >
              <WasteTypeSelect />
            </Form.Item>
            <Form.Item label={intl.formatMessage({ id: langContext + '.fields.amount' })}>
              <Input.Group compact>
                <Form.Item
                  name={'amount'}
                  label={intl.formatMessage({ id: langContext + '.fields.amount' })}
                  noStyle
                  rules={[
                    { required: true }
                  ]}
                >
                  <InputNumber placeholder={intl.formatMessage({ id: langContext + '.fields.value' })}
                    defaultValue={1000}
                    formatter={(value) => `${value}`.replace(/(\d)(\d{2})$/, "$1,$2")}
                    onChange={onChange}
                  />
                </Form.Item>
                <Form.Item
                  name={['measurement_unit', 'uid']}
                  label={intl.formatMessage({ id: 'components.measurement-unit-select.title' })}
                  noStyle
                  rules={[
                    { required: true }
                  ]}
                >
                  <MeasurementUnitSelect />
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item
              name={'estimated_date'}
              label={intl.formatMessage({ id: langContext + '.fields.estimated-date' })}
              rules={[
                { required: true }
              ]}
            >
              <DatePicker disabledDate={disabledDate}  />
            </Form.Item>
            <Form.Item name={'photo'} label={intl.formatMessage({ id: langContext + '.fields.photo' })}>
              <Upload customRequest={uploadCustomRequest} beforeUpload={uploadBeforeValidation} multiple={false}>
                <Button icon={<UploadOutlined />}><FormattedMessage id={`${langContext}.fields.load-photo`} /></Button>
                {data && data.photo && <img src={config.api.services + 'construction/waste/produce/photo?uid=' + data.uid + '&type=mini'} />}
              </Upload>
            </Form.Item>
            <Form.Item name={'own_transport'} label={intl.formatMessage({ id: langContext + '.fields.own-transport'})}>
              {
                data.own_transport ? (<Switch defaultChecked />) : (<Switch/>)
              }
            </Form.Item>
          </Form>
        }
      </Modal>
    </>
  );
}

